import React from 'react';

const About = ({ lang }) => {
  const isRtl = lang === 'ar';

  return (
    <section id="about" className="about-section">
      <div className="container-limited">
        <div className={`about-grid ${isRtl ? 'rtl-grid' : 'ltr-grid'}`}>
          
          <div className="about-text">
            {/* استخدام clamp لضمان عدم تخطي حجم معين عند التكبير */}
            <h2 className="about-title">
                {isRtl ? 'نبذه عنا' : 'ABOUT US'}
            </h2>
            <div className="about-line"></div>
            
            <h3 className="about-subtitle">
              {isRtl ? 'رواد في مجال المنظفات والمطهرات ومنتجات العناية الشخصية وحلول العناية بالسيارات' : 'Leaders in Detergents, Disinfectants, Personal Care, and Automotive Care Solutions'}
            </h3>

            <div className="about-description">
              {isRtl ? (
                <>
                  نحن في <span className="gold-highlight">يام انترناشونال للصناعات</span> نسعى دائماً لتقديم أفضل الحلول الكيميائية والمنظفات ذات الجودة العالمية. 
                  نلتزم تماماً بمعايير السلامة والبيئة من خلال مصنعنا المتطور، لنقدم منتجات تضمن الفعالية القصوى مع الحفاظ على سلامة عملائنا.
                </>
              ) : (
                <>
                  At <span className="gold-highlight">YAM International Industries</span>, we strive to provide the best chemical solutions and detergents. 
                  Committed to global standards, we deliver products designed for maximum efficiency and safety.
                </>
              )}
            </div>
          </div>

          <div className="about-visual">
            <div className="main-visual-box">
               <div className="gold-experience-card">
                  <h4 className="card-title">
                    {isRtl ? 'الجودة أولاً' : 'Quality First'}
                  </h4>
                  <p className="card-sub">
                    {isRtl ? 'منذ عام ٢٠١٨' : 'Since 2018'}
                  </p>
               </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        .about-section {
          padding: clamp(80px, 12vh, 150px) 0 !important;
          background-color: #ffffff !important;
          font-family: 'Cairo', sans-serif !important;
        }

        .container-limited {
          width: 90% !important;
          max-width: 1200px !important;
          margin: 0 auto !important;
        }

        .about-grid {
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: clamp(40px, 5vw, 80px);
          align-items: center;
        }

        .about-text {
          text-align: ${isRtl ? 'justify' : 'left'} !important;
          direction: ${isRtl ? 'rtl' : 'ltr'};
        }

        /* هنا التحكم الذكي في الحجم (الحد الأدنى 2.5rem والحد الأقصى 4rem) */
        .about-title {
          font-size: clamp(2.5rem, 4vw, 3.8rem) !important;
          font-weight: 900 !important;
          color: #1a3a5a !important;
          margin-bottom: 20px !important;
          line-height: 1.1 !important;
        }

        .about-line {
          width: 80px;
          height: 5px;
          background: #d4af37;
          margin-bottom: clamp(20px, 3vw, 35px);
          border-radius: 2px;
          margin-left: ${isRtl ? 'auto' : '0'};
          margin-right: ${isRtl ? '0' : 'auto'};
        }

        .about-subtitle {
          color: #d4af37 !important;
          font-size: clamp(1.4rem, 2vw, 1.8rem) !important;
          margin-bottom: 20px;
          font-weight: 700 !important;
        }

        /* النص الوصفي (الحد الأدنى 1.1rem والحد الأقصى 1.7rem) لكي لا يكبر بجنون */
        .about-description {
          font-size: clamp(1.1rem, 1.6vw, 1.7rem) !important;
          line-height: 1.8 !important;
          color: #334155 !important;
          font-weight: 600 !important;
        }

        .gold-highlight {
          color: #d4af37 !important;
          font-weight: 800 !important;
        }

        .main-visual-box {
          height: clamp(350px, 40vh, 500px);
          background: #1a3a5a url("https://www.yam-ii.com/yam_api/uploads/YAM International Industries_story.jpg") center/cover no-repeat;
          border-radius: 30px;
          box-shadow: 0 30px 60px rgba(26, 58, 90, 0.1);
          position: relative;
        }

        .gold-experience-card {
          position: absolute;
          bottom: -20px;
          ${isRtl ? 'left: -20px;' : 'right: -20px;'}
          background-color: #d4af37;
          padding: 20px 30px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(212, 175, 55, 0.3);
        }
        
        .card-title { font-weight: 800; font-size: 1.2rem; margin: 0; color: #1a3a5a; }
        .card-sub { font-size: 1rem; margin-top: 5px; font-weight: 600; color: #1a3a5a; }

        @media (max-width: 991px) {
          .about-grid { grid-template-columns: 1fr; }
          .about-text { text-align: center !important; }
          .about-line { margin: 0 auto 20px !important; }
          .gold-experience-card { left: 50% !important; right: auto !important; transform: translateX(-50%); width: 70%; }
        }
      `}</style>
    </section>
  );
};

export default About;